import Box from "@mui/material/Box";
import { TooltipProps } from "recharts";
import React from "react";

type ChartTooltipProps = TooltipProps<number, string> & {
    suffix?: string;
};

export const ChartTooltip: React.FC<ChartTooltipProps> = ({
                                                              active,
                                                              payload,
                                                              suffix = "",
                                                          }) => {
    if (active && payload?.length) {
        const date = payload[0]?.payload?.date || '';
        return (
          <Box sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
          }}>
            <Box
              sx={{
                color: "#fff",
                fontWeight: 600,
                background: "rgba(255, 255, 255, 0.3)",
                padding: "4px 8px",
                borderRadius: "4px",
                width: "fit-content",
                // marginBottom: "4px",
              }}
              >
                <div>{`${payload[0]?.value} ${suffix}`}</div>
            </Box>
            <Box sx={{
              color: "#fff",
              fontWeight: 600,
              background: "rgba(174, 174, 174, 0.8)",
              padding: "4px 8px",
              borderRadius: "4px",
              }}>
                <div>{date}</div>
            </Box>
          </Box>
        );
    }

    return null;
};
